module.exports = __webpack_public_path__ + "linea-software-10.8fe30102fca386ab297c.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/linea/fonts/linea-software-10.ttf
// module id = ../../../../../src/assets/linea/fonts/linea-software-10.ttf
// module chunks = styles